import { Grid, InputLabel, Select, Input, FormHelperText, MenuItem } from '@material-ui/core';
import CustomMaskedInput from 'components/MaskedInput';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { run } from 'validations/ruleRunner';

import Validations from './validations';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  delivery: any;
  enabledValidation: boolean;
  currencies: any;
  onEdit?: () => void;
}

interface IStates {
  showErrors: boolean;
  validationErrors: any;
}

class FixedValue extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      showErrors: false,
      validationErrors: [],
    };
  }

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };

  handleChange(prop: string, value: any) {
    let { delivery } = this.props;
    delivery[prop] = value;
    if (this.props.onEdit) {
      this.props.onEdit();
    }
    this.props.dispatch({ type: 'CHANGE_PHYSICAL_DELIVERY', delivery });
  }

  componentDidUpdate(prevProps: IProps) {
    const { delivery } = this.props;

    if ((prevProps.enabledValidation === false && this.props.enabledValidation) || delivery !== prevProps.delivery) {
      let newState = { ...this.state };
      newState.validationErrors = run(delivery, Validations);
      this.setState(newState);
    }
  }
  render() {
    const { delivery, currencies } = this.props;
    return (
      <>
        <Grid item xs={12}>
          <InputLabel>Moeda</InputLabel>
          <Select
            id='currency_id'
            fullWidth
            value={delivery?.currency_id ? delivery.currency_id : 1}
            input={<Input disableUnderline fullWidth />}
            onChange={(value: any) => this.handleChange('currency_id', value.target.value)}
            disabled
          >
            {currencies?.length &&
              currencies.map((curr: any) => (
                <MenuItem key={`curr-${curr.code}`} value={curr.id} disabled={curr.code !== 'BRL'}>
                  {curr.code} - {curr.name}
                </MenuItem>
              ))}
          </Select>
          <FormHelperText>Mesma moeda cadastrada no preço</FormHelperText>
        </Grid>
        <Grid item xs={12}>
          <CustomMaskedInput
            label='Valor do frete'
            fullWidth={true}
            disableUnderline
            id='delivery_value'
            mask='money'
            helperText={this.isValid('delivery_value') ? this.errorFor('delivery_value') : 'Ex: 10,00'}
            error={this.isValid('delivery_value')}
            value={delivery.delivery_value}
            onChange={(value: any) => this.handleChange('delivery_value', value)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomMaskedInput
            label='Prazo de entrega'
            fullWidth={true}
            disableUnderline
            id='delivery_days'
            mask='number'
            helperText={this.isValid('delivery_days') ? this.errorFor('delivery_days') : 'Dias corridos'}
            error={this.isValid('delivery_days')}
            value={delivery.delivery_days}
            onChange={(value: any) => this.handleChange('delivery_days', value)}
            InputLabelProps={{
              shrink: true,
            }}
            endAdornment='Dias'
          />
        </Grid>
      </>
    );
  }
}
function mapStateToProps(state: any) {
  return {
    currencies: state.orbita.Currency.list,
    delivery: state.components.physicalDelivery,
  };
}

export default connect(mapStateToProps)(FixedValue);
